import React, { useEffect, useState } from "react";
import Head from "next/head";
import Gallery from "../../components/UI/Gallery";
import qs from "qs";
import Pagination from "../../components/UI/Pagination";
import { useRouter } from "next/router";
import { track } from "../../utils/amplitude";
import InAppSubscriptionForm from "../../components/sections/InAppSubscriptionForm";
import TitleProduct from "../../components/sections/TitleProduct";

function filterNonNull(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
}

export default function PaywallsGallery(props) {
  const router = useRouter();
  const [categories, setCategories] = useState([]);
  const [verticals, setVerticals] = useState([]);
  const [callToActions, setCallToActions] = useState([]);
  const [components, setComponents] = useState([]);
  const [gallery, setGallery] = useState(props.gallery);
  const [isLoading, setIsLoading] = useState(false);
  let debounceTimer = null;

  const [params, setParams] = useState({
    ...router.query,
  });

  const onChangeHandler = (filters) => {
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          ...filters,
        },
      },
      undefined,
      {
        shallow: true,
      }
    );
  };

  useEffect(() => {
    setIsLoading(true);
    fetch(
      `https://api.apphud.com/gallery/apps?${qs.stringify(
        filterNonNull(router.query)
      )}`
    )
      .then((r) => r.json())
      .then((data) => {
        setGallery(data);
        setIsLoading(false);
        if (router.query.q) {
          track("paywall_gallery_searched", { query: router.query.q });
        }
      })
      .catch(() => {});
  }, [router.query]);

  useEffect(() => {
    fetch("https://api.apphud.com/gallery/categories")
      .then((r) => r.json())
      .then((data) => {
        setCategories(data);
      })
      .catch(() => {});
    fetch("https://api.apphud.com/gallery/verticals")
      .then((r) => r.json())
      .then((data) => {
        setVerticals(data);
      })
      .catch(() => {});
    fetch("https://api.apphud.com/gallery/call_to_actions")
      .then((r) => r.json())
      .then((data) => {
        setCallToActions(data);
      })
      .catch(() => {});
    fetch("https://api.apphud.com/gallery/components")
      .then((r) => r.json())
      .then((data) => {
        setComponents(data);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="wrapper no-overflow-hidden">
      <Head>
        <title>Mobile Paywall Gallery – Apphud</title>
        <link rel="canonical" href="https://apphud.com/gallery" />
        <meta
          name="og:title"
          content="Free to Use Mobile Paywall Screens Gallery - Apphud"
        />
        <meta
          name="keywords"
          content="mobile paywalls, mobile paywall gallery, mobile paywall examples"
        />
        <meta
          name="description"
          content="Apphud's Paywall gallery includes 150+ free downloadable paywalls and screens. Explore best practices, get inspired and increase your conversion rate on the app stores."
        />
      </Head>
      <TitleProduct
        title={"Mobile Paywall Gallery\n from Apphud"}
        text={
          "Explore best practices, get inspired, and increase your conversion rates with 150+ free\n downloadable paywalls and screens"
        }
      />
      <div className={"container"}>
        <Gallery
          countFilters={Object.keys(router.query).length}
          isLoading={isLoading}
          onChange={onChangeHandler}
          items={gallery?.results}
          categories={categories?.results}
          verticals={verticals?.results}
          callToActions={callToActions?.results}
          components={components?.results}
          pagination={<Pagination meta={gallery?.meta} />}
        />
        <br />
        <br />
        <br />
        <br />
        <InAppSubscriptionForm />
      </div>
    </div>
  );
}

export async function getServerSideProps(ctx) {
  const apps = await fetch(
    `https://api.apphud.com/gallery/apps?${qs.stringify(
      filterNonNull(ctx.query)
    )}`
  );
  return {
    props: {
      gallery: await apps.json(),
    },
  };
}
